import { createMultiStyleConfigHelpers as t } from "@chakra-ui/react";
const e = t(["container", "iconButton", "badgeContainer", "badge"]), o = e.defineMultiStyleConfig({
  baseStyle: {
    container: {
      position: "relative",
      width: "fit-content",
      height: "fit-content"
    },
    iconButton: {
      borderRadius: "full"
    },
    badgeContainer: {
      position: "absolute",
      display: "inline",
      width: "48px",
      right: "-24px",
      top: "-14px",
      textAlign: "center"
    },
    badge: {
      background: "red.500",
      color: "white",
      borderRadius: "2xl",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: "semibold",
      lineHeight: "12px"
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
});
export {
  o as default
};
